let TestModel = require('@/mixins/Forms/2022/TestModel')

module.exports = {

    mixins: [TestModel],

    methods: {
        initTest() {

            // Construction Inspection
            this.form.construction_inspection.result = true;
            _.each(this.form.construction_inspection.questions, question => {
                if (!question.answer) {
                    this.form.construction_inspection.result = false;
                }
            })

            // Functional Test
            this.form.functional_test.result = true;
            _.each(this.form.functional_test.steps, step => {
                _.each(step.questions, question => {
                    if(!this.skipAnswersIds.includes(question.id)) {
                        if (!question.answer && (!question.hasOwnProperty('display') || question.display)) {
                            this.form.functional_test.result = false;
                        }
                    }
                })
            })

            // Test Restult
            this.form.testResult = (this.form.construction_inspection.result && this.form.functional_test.result);

            //
            this.functionalTestEvaluation();
        },

        functionalTestEvaluation() {
            // Needs to be called from the test component.
        },
    },
}
